module.exports = false;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.library.js
 ** module id = 418
 ** module chunks = 1
 **/